import * as PIXI from "pixi.js";
import { ControlConstants } from "../../control/constant/ControlConstants";
import { VerticalLayout } from "../../control/layout/VerticalLayout";
import { ButtonProperties } from "../../control/properties/ButtonProperties";
import { PanelProperties } from "../../control/properties/PanelProperties";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { ToggleButtonProperties } from "../../control/properties/ToggleButtonProperties";
import { CommonLang } from "../lang/CommonLang";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
import { AbstractViewProperties } from "./AbstractViewProperties";
/*
 * AbstractOptionsMenuProperties.ts
 */
export class AbstractOptionsMenuProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            (this.backgroundAlpha === other.backgroundAlpha) &&
            (this.backgroundColour === other.backgroundColour) &&
            this.optionsButtonProperties.equals(other.optionsButtonProperties) &&
            this.panelProperties.equals(other.panelProperties) &&
            this.optionsButtonProperties.equals(other.optionsButtonProperties) &&
            this.SFXButtonProperties.equals(other.SFXButtonProperties) &&
            this.backgroundSoundButtonProperties.equals(other.backgroundSoundButtonProperties) &&
            this.homeButtonProperties.equals(other.homeButtonProperties) &&
            this.helpButtonProperties.equals(other.helpButtonProperties) &&
            this.payTableButtonProperties.equals(other.payTableButtonProperties) &&
            this.depositButtonProperties.equals(other.depositButtonProperties) &&
            this.responsibleGamingButtonProperties.equals(other.responsibleGamingButtonProperties) &&
            this.dghButtonProperties.equals(other.dghButtonProperties) &&
            (this.responsiveLayout === other.responsiveLayout) &&
            (this.hasPayTable === other.hasPayTable);
    }
    setDefaultValues() {
        this.optionsButtonProperties = new ToggleButtonProperties(CommonStyle.OPTIONS_TOGGLE_BUTTON, CommonStyle.MODULE);
        this.optionsButtonProperties.accessibleOptions.accessibleHint = "Options";
        this.panelProperties = new PanelProperties();
        this.panelProperties.layout = new VerticalLayout(0);
        this.optionsMenuProperties = new SpriteProperties(null, CommonStyle.MODULE);
        this.SFXButtonProperties = new ToggleButtonProperties(CommonStyle.OPTIONS_MENU_AUDIO_BUTTON, CommonStyle.MODULE);
        this.SFXButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_SFX_SOUND, ControlConstants.LEFT);
        this.SFXButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.backgroundSoundButtonProperties = new ToggleButtonProperties(CommonStyle.OPTIONS_MENU_AUDIO_BUTTON, CommonStyle.MODULE);
        this.backgroundSoundButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_BACKGROUND_SOUND, ControlConstants.LEFT);
        this.backgroundSoundButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.homeButtonProperties = new ButtonProperties(CommonStyle.OPTIONS_MENU_HOME_BUTTON, CommonStyle.MODULE);
        this.homeButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_LOBBY, ControlConstants.LEFT);
        this.homeButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.helpButtonProperties = new ButtonProperties(CommonStyle.OPTIONS_MENU_HELP_BUTTON, CommonStyle.MODULE);
        this.helpButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_HELP, ControlConstants.LEFT);
        this.helpButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.payTableButtonProperties = new ButtonProperties(CommonStyle.OPTIONS_MENU_PAY_TABLE_BUTTON, CommonStyle.MODULE);
        this.payTableButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_PAYS, ControlConstants.LEFT);
        this.payTableButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.depositButtonProperties = new ButtonProperties(CommonStyle.OPTIONS_MENU_DEPOSIT_BUTTON, CommonStyle.MODULE);
        this.depositButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_DEPOSIT, ControlConstants.LEFT);
        this.depositButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.responsibleGamingButtonProperties = new ButtonProperties(CommonStyle.OPTIONS_MENU_RESPONSIBLE_GAMING_BUTTON, CommonStyle.MODULE);
        this.responsibleGamingButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_RESPONSIBLE_GAMING, ControlConstants.LEFT);
        this.responsibleGamingButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.dghButtonProperties = new ButtonProperties(CommonStyle.OPTIONS_MENU_GAME_HISTORY_BUTTON, CommonStyle.MODULE);
        this.dghButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.OPTIONS_MENU, null, CommonLang.OPTIONS_DGH, ControlConstants.LEFT);
        this.dghButtonProperties.textFieldOffset = new PIXI.Point(-300, 0);
        this.responsiveLayout = false;
        this.hasPayTable = false;
    }
}
//# sourceMappingURL=AbstractOptionsMenuProperties.js.map